import { IconInfoSquareRounded } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Tooltip, Typography } from '@rossum/ui/material';

type CustomLegendTooltipProps = {
  label: string;
  tooltip: string;
  Icon?: JSX.Element;
};

export const CustomLegendTooltip = ({
  label,
  tooltip,
  Icon,
}: CustomLegendTooltipProps) => {
  return (
    <Stack
      direction="row"
      color="text.secondary"
      spacing={1}
      useFlexGap
      sx={{ alignItems: 'center' }}
    >
      <Typography variant="body2">{label}</Typography>
      <Tooltip title={tooltip}>
        {Icon ?? (
          <SvgIcon fontSize="small">
            <IconInfoSquareRounded />
          </SvgIcon>
        )}
      </Tooltip>
    </Stack>
  );
};
